var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pb-1",style:({
      color: _vm.color(
        _vm.checkin.talkingPointCount,
        false,
        _vm.overrideColor || _vm.$vuetify.theme.themes.light.performance
      )
    })},[_c('v-avatar',{attrs:{"size":"20","color":_vm.color(
          _vm.checkin.talkingPointCount,
          true,
          _vm.overrideColor || _vm.$vuetify.theme.themes.light.performance
        )}},[_vm._v(" "+_vm._s(_vm.checkin.talkingPointCount)+" ")]),_c('span',{staticClass:"mx-1"},[_vm._v(" Talking Points ")]),(_vm.checkin.hasUrgentTalkingPoint)?_c('v-icon',{attrs:{"color":"error","small":""}},[_vm._v(" error ")]):_vm._e()],1),_c('div',{staticClass:"pb-1",style:({
      color: _vm.color(
        _vm.checkin.actionItemCount,
        false,
        _vm.overrideColor || _vm.$vuetify.theme.themes.light.info
      )
    })},[_c('v-avatar',{attrs:{"size":"20","color":_vm.color(
          _vm.checkin.actionItemCount,
          true,
          _vm.overrideColor || _vm.$vuetify.theme.themes.light.info
        )}},[_vm._v(" "+_vm._s(_vm.checkin.actionItemCount)+" ")]),_c('span',{staticClass:"mx-1"},[_vm._v(" Action Items ")]),(_vm.checkin.pastDueActionItems > 0)?_c('v-icon',{attrs:{"color":"error","small":""}},[_vm._v(" error ")]):_vm._e()],1),(_vm.checkin.goalCount != null && _vm.settings.isGoalsActive)?_c('div',{style:({
      color: _vm.color(
        _vm.checkin.goalCount,
        false,
        _vm.overrideColor || _vm.$vuetify.theme.themes.light.success
      )
    })},[_c('v-avatar',{attrs:{"size":"20","color":_vm.color(
          _vm.checkin.goalCount,
          true,
          _vm.overrideColor || _vm.$vuetify.theme.themes.light.success
        )}},[_vm._v(" "+_vm._s(_vm.checkin.goalCount)+" ")]),_c('span',{staticClass:"mx-1"},[_vm._v(" Goals ")]),(_vm.checkin.pastDueGoals > 0)?_c('v-icon',{attrs:{"color":"error","small":""}},[_vm._v(" error ")]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }